import { required, numeric } from 'vuelidate/lib/validators'
import generalConfig from '@/config'
import dialCodes from './dialCodes.json'

const userGenders = generalConfig.userGenders
const campaignStatus = generalConfig.campaignStatus

// const pairingStatus = {
//   NEW: 0,
//   ELIMINATION_PENDING: 1,
//   APPROVED: 2,
//   INVITED: 3,
//   ACCEPT: 4,
//   REJECT: 5,
//   INQUIRY: 6,
//   CO_REJECT: 7
// }

const pairingStatus = {
  NEW: 0,
  ELIMINATION_PENDING: 1,
  APPROVED: 2,
  INVITED: 3,
  INTERESTED: 4,
  NOT_INTERESTED: 5,
  ACCEPTED: 6,
  NOT_ACCEPTED: 7,
  INQUIRY: 8
}

const eliminationStatus = {
  NEW: 0,
  PENDING: 3,
  SELECTED: 1,
  ELIMINATED: 2
}

const pairingStatusDisplay = {
  [pairingStatus.NEW]: 'New',
  [pairingStatus.ELIMINATION_PENDING]: 'In Elimination',
  [pairingStatus.APPROVED]: 'Approved',
  [pairingStatus.INVITED]: 'Invited',
  [pairingStatus.INTERESTED]: 'Interested',
  [pairingStatus.NOT_INTERESTED]: 'Not Interested',
  [pairingStatus.ACCEPTED]: 'Accepted',
  [pairingStatus.NOT_ACCEPTED]: 'Not Accepted',
  [pairingStatus.INQUIRY]: 'Inquiry'

}

const payoutStatus = {
  PENDING: 0,
  INCOMPLETE: 1,
  SUBMITTED: 3,
  CONFIRMED: 2
}

const payoutStatusDisplay = {
  [payoutStatus.PENDING]: 'Pending Payout',
  [payoutStatus.INCOMPLETE]: 'Incomplete Payout',
  [payoutStatus.SUBMITTED]: 'Payout Submitted',
  [payoutStatus.CONFIRMED]: 'Payout Confirmed'
}

const campaignStatusDisplayForClients = {
  [campaignStatus.DRAFT]: 'Draft', // not shown to client
  [campaignStatus.PENDING_CLIENT_APPROVAL]: 'Pending',
  [campaignStatus.PAIRING_BRIEF]: 'Approved',
  [campaignStatus.PAIRING_INFLUENCER]: 'Pairing Influencers',
  [campaignStatus.RATE_CARD]: 'On Going',
  [campaignStatus.ONGOING]: 'On Going',
  [campaignStatus.REVIEW]: 'Review',
  [campaignStatus.COMPLETE]: 'Completed'
}

const postStatus = {
  DRAFT: 0,
  AD_STRATEGIST_PENDING: 1,
  AD_STRATEGIST_REJECT: 2,
  CLIENT_PENDING: 3,
  CLIENT_REJECT: 4,
  CLIENT_APPROVE: 5,
  LIVE: 6
}

const paymentStatus = {
  NEW: 0,
  PAID: 1,
  UNPAID: 2,
  PROCESSING: 3,
  ERROR: 4,
  PARTIAL: 5,
  APPROVAL_FINANCE: 6,
  APPROVAL_LEAD: 7,
  RELEASED_FINANCE: 8
}

const paymentConsExportTypes = {
  CO: 1,
  FINANCE: 2
}

// payment consolidation section numbers
const paymentConsSectionIDs = {
  IMPORTED: 'imported',
  BATCH_ONE: 'b1',
  BATCH_TWO: 'b2',
  APPROVAL_FINANCE: 'approvalFinance',
  APPROVAL_LEAD: 'approvalLead',
  WIP_FINANCE: 'partial',
  PAID: 'completed'
}

const postStatusDisplay = {
  [postStatus.DRAFT]: 'Draft',
  [postStatus.AD_STRATEGIST_PENDING]: 'Pending AS approval',
  [postStatus.CLIENT_PENDING]: 'Pending client approval',
  [postStatus.CLIENT_APPROVE]: 'Client approved',
  [postStatus.LIVE]: 'Post is live'
}

const imsStatuses = {
  NEW: {
    text: 'Please confirm payout',
    value: 0
  },
  SUBMITTED: {
    text: 'Submitted',
    value: 1
  },
  NOT_SUBMITTED: {
    text: 'Not Submitted',
    value: 2
  }
}

const clientPaymentStatus = {
  UNPAID: 0,
  PENDING: 1,
  PAID: 2
}

const tableActions = [{
  name: 'Change Status',
  action: 'changeStatus',
  icon: 'arrow-left-right'
}, {
  name: 'Delete',
  action: 'deleteCampaign',
  icon: 'delete'
}, {
  name: 'Archive',
  action: 'archiveCampaign',
  icon: 'archive'
}]

const clientPaymentStatusDisplay = {
  [clientPaymentStatus.UNPAID]: 'Unpaid',
  [clientPaymentStatus.PENDING]: 'Pending',
  [clientPaymentStatus.PAID]: 'Paid'
}

const userGenderDisplay = [
  {
    value: userGenders.NON_BINARY,
    text: 'No preference'
  },
  {
    value: userGenders.MALE,
    text: 'Male'
  },
  {
    value: userGenders.FEMALE,
    text: 'Female'
  }
]

const targetAudience = {
  AGE: {
    GROUP_A: '13-17',
    GROUP_B: '18-24',
    GROUP_C: '25-34',
    GROUP_D: '35-44',
    GROUP_E: '45-64'
  },
  GENDER: {
    FEMALE: 'Female',
    MALE: 'Male',
    NO_PREFERENCE: '-'
  },
  LOCATION: {
    SINGAPORE: 'SG',
    THAILAND: 'TH',
    INDONESIA: 'ID',
    PHILIPPINES: 'PH',
    VIETNAM: 'VN',
    MALAYSIA: 'MY',
    HONGKONG: 'HK',
    NO_PREFERENCE: ''
  }
}

const targetAudienceDisplay = {
  AGE: [
    {
      value: targetAudience.AGE.GROUP_A,
      text: '13 - 17'
    },
    {
      value: targetAudience.AGE.GROUP_B,
      text: '18 - 24'
    },
    {
      value: targetAudience.AGE.GROUP_C,
      text: '25 - 34'
    },
    {
      value: targetAudience.AGE.GROUP_D,
      text: '35 - 44'
    },
    {
      value: targetAudience.AGE.GROUP_E,
      text: '45 - 64'
    }
  ],
  GENDER: [
    {
      value: targetAudience.GENDER.FEMALE,
      text: 'Female'
    },
    {
      value: targetAudience.GENDER.MALE,
      text: 'Male'
    },
    {
      value: targetAudience.GENDER.NO_PREFERENCE,
      text: 'No Preference'
    }
  ],
  LOCATION: [
    {
      value: targetAudience.LOCATION.SINGAPORE,
      text: 'Singapore'
    },
    {
      value: targetAudience.LOCATION.THAILAND,
      text: 'Thailand'
    },
    {
      value: targetAudience.LOCATION.INDONESIA,
      text: 'Indonesia'
    },
    {
      value: targetAudience.LOCATION.PHILIPPINES,
      text: 'Philippines'
    },
    {
      value: targetAudience.LOCATION.VIETNAM,
      text: 'Vietnam'
    },
    {
      value: targetAudience.LOCATION.MALAYSIA,
      text: 'Malaysia'
    },
    {
      value: targetAudience.LOCATION.HONGKONG,
      text: 'Hong Kong'
    }
  ],
  PLATFORM: [
    {
      value: 'Instagram',
      text: 'Instagram'
    },
    {
      value: 'Tiktok',
      text: 'Tiktok'
    },
    {
      value: 'Youtube',
      text: 'Youtube'
    },
    {
      value: 'LinkedIn',
      text: 'LinkedIn'
    },
    {
      value: 'Twitter',
      text: 'X (Twitter)'
    },
    {
      value: 'Blog',
      text: 'Blog'
    },
    {
      value: 'Discord',
      text: 'Discord'
    },
    {
      value: 'Twitch',
      text: 'Twitch'
    },
    {
      value: 'Others',
      text: 'Others'
    }
  ]
}

const userSegment = {
  BRAND_FIT: 'Brand Fit',
  CONTENT_FIT: 'Content Fit',
  ENGAGEMENT_FIT: 'Engagement Fit'
}

const userSegmentDisplay = [
  {
    value: userSegment.BRAND_FIT,
    text: 'Brand Fit'
  },
  {
    value: userSegment.CONTENT_FIT,
    text: 'Content Fit'
  },
  {
    value: userSegment.ENGAGEMENT_FIT,
    text: 'Engagement Fit'
  }
]

const actionRequired = {
  TIME: {
    LESS_1_HOUR: 0,
    MORE_1_HOUR: 1
  },
  ACTION: {
    RECEIVE: 0,
    COLLECT: 1,
    VISIT_WEB: 2,
    VISIT_INTERACT: 3,
    IN_DEPTH: 4
  },
  RECEIVE: {
    NA: 0,
    PRODUCT: 1,
    EXPERIENCE: 2
  },
  VALUE: {
    NA: 0,
    LESS_50: 1,
    MORE_50: 2
  }
}

const actionRequiredDisplay = {
  TIME: [
    {
      value: actionRequired.TIME.LESS_1_HOUR,
      text: '< 1 hour'
    },
    {
      value: actionRequired.TIME.MORE_1_HOUR,
      text: '> 1 hour'
    }
  ],
  ACTION: [
    {
      value: actionRequired.ACTION.RECEIVE,
      text: 'Receive Something'
    },
    {
      value: actionRequired.ACTION.COLLECT,
      text: 'Collect Something'
    },
    {
      value: actionRequired.ACTION.VISIT_WEB,
      text: 'Visit website/app/share past photo/stories/phone call'
    },
    {
      value: actionRequired.ACTION.VISIT_INTERACT,
      text: 'Visit + Minimal Interaction'
    },
    {
      value: actionRequired.ACTION.IN_DEPTH,
      text: 'In-depth Experience'
    }
  ],
  RECEIVE: [
    {
      value: actionRequired.RECEIVE.NA,
      text: 'N/A'
    },
    {
      value: actionRequired.RECEIVE.PRODUCT,
      text: 'Product'
    },
    {
      value: actionRequired.RECEIVE.EXPERIENCE,
      text: 'Experience'
    }
  ],
  VALUE: [
    {
      value: actionRequired.VALUE.NA,
      text: 'N/A'
    },
    {
      value: actionRequired.VALUE.LESS_50,
      text: '< $50'
    },
    {
      value: actionRequired.VALUE.MORE_50,
      text: '> $50'
    }
  ]
}

const campaignActivationStatus = {
  ACTIVATED: 1,
  DEACTIVATED: 0
}

const campaignStatusFlow = {
  approve: {
    [campaignStatus.DRAFT]: [campaignStatus.PENDING_CLIENT_APPROVAL],
    [campaignStatus.PENDING_CLIENT_APPROVAL]: [campaignStatus.PAIRING_BRIEF],
    [campaignStatus.PAIRING_BRIEF]: [campaignStatus.PAIRING_INFLUENCER],
    [campaignStatus.PAIRING_INFLUENCER]: [campaignStatus.ONGOING],
    [campaignStatus.ONGOING]: [campaignStatus.COMPLETE]
  }
}

const queryType = {
  EQUAL: 1,
  LIKE: 2
}

const campaignModelSectionType = {
  CAMPAIGN_SUMMARY: 1,
  CONTENT_ANGLE: 2,
  INFLUENCER_SELECTION: 3,
  BUDGET_ALLOCATION: 4,
  VIDEO_BRIEF: 5,
  EVENT_BRIEF: 6
}

const pairingBriefModelSectionType = {
  CAMPAIGN_SUMMARY: 1,
  CAMPAIGN_DETAILS: 2
}

const campaignType = {
  NO_PREFERENCE: 'No Preference',
  STORY_TELL: 'Storytell',
  AMPLIFY: 'Amplify',
  // Uncut: 'Uncut',
  AOK: 'AOK/Uncut',
  Others: 'Others',
  LoadingFees: 'Loading Fees'
}

const campaignTypeDisplay = [
  // {
  //   value: campaignType.NO_PREFERENCE,
  //   text: ''
  // },
  {
    value: campaignType.STORY_TELL,
    text: 'Storytell'
  },
  {
    value: campaignType.AMPLIFY,
    text: 'Amplify'
  },
  {
    value: campaignType.AOK,
    text: 'AOK/Uncut'
  },
  // {
  //   value: campaignType.Uncut,
  //   text: 'Uncut'
  // },
  {
    value: campaignType.Others,
    text: 'Others'
  },
  {
    value: campaignType.LoadingFees,
    text: 'Loading Fees'
  }
]

const bfsTypes = {
  STORY_TELL: 'Storytell',
  AOK: 'KOBE Uncut',
  UGC: 'UGC',
  KOBE_LITE: 'KOBE Lite'
}

const campaignStage = {
  ALL: 'All',
  ACTIVATING: 'Activating',
  PAIRING: 'Pairing',
  COCREATING: 'Co-Creating',
  REVIEW: 'Review',
  COMPLETE: 'Complete'
}

const campaignStageDisplay = [
  {
    value: campaignType.ALL,
    text: 'All'
  },
  {
    value: campaignType.ACTIVATING,
    text: 'Activating'
  },
  {
    value: campaignType.PAIRING,
    text: 'Pairing'
  },
  {
    value: campaignType.COCREATING,
    text: 'Co-Creating'
  },
  {
    value: campaignType.REVIEW,
    text: 'Review'
  },
  {
    value: campaignType.COMPLETE,
    text: 'Complete'
  }
]

const pairingSendStatus = {
  DRAFT: 0,
  SENT: 1,
  SIGNED: 3
}

const pairingSendStatusDisplay = {
  [pairingSendStatus.DRAFT]: 'Draft',
  [pairingSendStatus.SENT]: 'Sent',
  [pairingSendStatus.SIGNED]: 'Signed'
}

const dashboardStatuses = {
  pendingAM: 1,
  pendingCC: 2,
  pendingCCShortList: 3,
  pendingAMRelease: 4,
  pendingAdmin: 5,
  pendingClient: 6
}

const dashboardStatusDisplay = {
  [dashboardStatuses.pendingAM]: `Pending AM's set up`,
  [dashboardStatuses.pendingCC]: `Pending CC's approval`,
  [dashboardStatuses.pendingCCShortList]: `Pending CC's shortlist`,
  [dashboardStatuses.pendingAMRelease]: `Pending AM's release to client`,
  [dashboardStatuses.pendingAdmin]: `Pending admin's approval`,
  [dashboardStatuses.pendingClient]: `Pending client's approval`
}

const campaignConfirmation = {
  approval: {
    [campaignStatus.DRAFT]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, campaign will be pending client appoval',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'question'
      },
      confirm: {
        title: 'Success',
        text: 'The campaign is now pending client approval'
      }
    },
    // [campaignStatus.PENDING_CLIENT_APPROVAL]: {
    //   confirmation: {
    //     title: 'Are you sure?',
    //     text: 'Upon confirmation, campaign brief to be finalized with no more changes to be made',
    //     confirmText: 'I agree',
    //     cancelText: 'Cancel',
    //     type: 'question'
    //   },
    //   confirm: {
    //     title: 'Approved',
    //     text: 'You have successfully approved this campaign. You can now view the approved campaigns in \'My Campaigns\' section located in Menu.'
    //   }
    // },
    [campaignStatus.PENDING_CLIENT_APPROVAL]: {
      confirmation: {
        title: 'Terms and Conditions',
        html: `<div style='text-align:left;margin-top:20px;height: 350px;overflow:auto;'><p>Terms and Conditions (Extract)<br/>
               Full Terms and Conditions: <a target='_blank' href='http://www.getkobe.com/advertiser-tnc/'>www.getkobe.com/advertiser-tnc</a></p>
               <p>
               These terms and conditions (the “Terms and Conditions”) are incorporated into the
               agreement entered into between Kobe Global Technologies Pte Ltd (UEN:
               201608755R) (“KOBE”) and the Client through the e-Quote.
               The Quote and these Terms and Conditions will be collectively referred to as the
               “Agreement”.
               </p>
               <h4>Services and Deliverables</h4>
               <p>
               1.1 KOBE will furnish to the Client the Campaign Brief and Content Creator Line Up
               described in the Quote, for the purposes of the Campaign. Guaranteed Deliverables
               presented in this quote refers to the total Deliverables for the entire Campaign.
               </p>
               <p>
               1.2 KOBE will use reasonable endeavors to furnish the Campaign Brief and Content
               Creator Line Up in accordance with the specifications in the Quote, as well as in
               accordance with any feedback and any reasonable additional instructions (whether
               written or verbal) given to KOBE by the Client or by an authorized representative of
               the Client.
               </p>
               <p>
               1.3 Client reserves the right to request for refund for unmet Deliverables if
               Guaranteed Deliverables stated in Quote is not achieved.
               </p>
               <h4>Amendments and Alterations</h4>
               <p>
               1.4 If Client decides to select Content Creators out of KOBE’s AI technology system,
               the Guaranteed Deliverables will no longer be guaranteed.
               </p>
               <p>
               1.5 Once the Campaign Brief and Content Creator Line Up have been furnished in
               the manner set out at clause 1.2 above, the Client must, not later than <b><u>three days</u></b>
               from the date of delivery (the “Response Period”), provide KOBE with confirmation
               on KOBE Influencer Management System (“IMS”) as to whether the Client has
               approved or disapproved the Campaign Brief and Content Creator Line Up. In the
               event that the Client fails to give such notice within the Response Period, the Client
               will be deemed to have approved the Campaign Brief and Content Creator Line Up.
               In the event that the Client gives notice of disapproval on the IMS, the Client must
               state with specificity the details of any reasonable alteration or amendments that the
               Client reasonably requires.
               </p>
               <p>
               1.6 If the Campaign Brief and Content Creator Line Up have been produced in the
               manner set out at clause 1.2 above, Content Creator will only do <b><u>1 shoot</u></b> and has
               full creative rights to the final execution of the post. KOBE will provide no more than
               <b><u>two rounds</u></b> of alterations or amendments, at no further increase in Fee, provided
               that such changes do not involve a material change in the specifications.
               </p>
               <p>
               1.7 To avoid doubt, the following alterations and amendments will be deemed to
               involve a material change for the purposes of clause 1.6 above:<br/>
               a. eliminating more than <b><u>20%</u></b> of Content Creator Line Up;<br/>
               b. any change in the <b><u>content format</u></b> of the Deliverables;<br/>
               c. <b><u>re-shooting</u></b> the content in whole
               </p>
               <p>
               1.8 Should the Client reasonably require any further rounds of alterations or
               amendments beyond the two provided for in clause 1.6 above, or any alterations or
               amendments involving a material change in the specifications, KOBE has the right to
               charge a fee for each round of alterations or amendments. The quantum of such a
               fee is to be determined by KOBE, entirely at KOBE’s discretion.
               Any reshoots are chargeable at 100% of the Fees.
               </p>
               <p>
               1.9 For the purposes of clauses 1.5 and 1.7 above, each consolidated request for
               alterations or amendments (e.g. 1 st instruction of edit on IMS for Campaign Brief and
               Report Abuse in Content Creator Draft Vetting Stage) is regarded as a request for
               one round of alterations and amendments. Each additional request (e.g. additional
               comment after 1 st instruction of edit on IMS for Campaign Brief or Report Abuse in
               Content Creator Draft Vetting Stage) is regarded as a request for an additional round
               of alterations and amendments.
               </p>
               <h4>Posting of Content on Social Media Platforms</h4>
               <p>
               1.10 KOBE Content Creator will post the content on the date mutually agreed on by
               the Parties in this Agreement. Should the Client, after the date of this Agreement,
               request to change the launch date, KOBE will have the right to charge an additional
               fee for each request. The quantum of such a fee is to be determined by KOBE,
               entirely at KOBE’s discretion.<br/>
               Reshoots are chargeable at 100% of the fees.
               </p>
               <p>
               1.11 Copyright of the content created (artistic, literary, musical or dramatic) belongs
               to the Content Creator.
               </p>
               <p>
               1.12 Client shall be allowed to share and/or re-post the content(s) on its official social
               media platform(s) provided:<br/>
               a. the content(s) is shared/re-posted (as the case may be) on the same platform it
               was originally posted on with acknowledgement and credit to Content Creator;<br/>
               b. the content(s) is shared/re-posted (as the case may be) in its entirety with no
               adaptation to the photo, video or caption;<br/>
               c. the content(s) is not shared/re-posted for purposes other than to publicise the
               Campaign;<br/>
               d. the Client shall remove the shared or re-posted content(s) if instructed by the
               Company; and<br/>
               e. the Client does not boost the content(s) via media ads.
               </p>
               1.13 The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. 
               The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.<br/>
               </div>`,
        confirmText: 'AGREE AND CONTINUE',
        cancelText: 'Cancel',
        type: 'info',
        input: 'checkbox'
      },
      confirm: {
        title: 'Approved',
        text: 'You have successfully approved this campaign brief.'
      }
    },
    [campaignStatus.PAIRING_BRIEF]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, pairing brief will be confirmed',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'question'
      },
      confirm: {
        title: 'Done',
        text: 'You have submitted the pairing brief'
      }
    },
    [campaignStatus.PAIRING_INFLUENCER]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, the campaign will officially start',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'question'
      },
      confirm: {
        title: 'Done',
        text: 'The campaign is live now'
      }
    },
    [campaignStatus.ONGOING]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, the campaign will be closed immediately',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'warning'
      },
      confirm: {
        title: 'Done',
        text: 'The campaign has stopped'
      }
    },
    [campaignStatus.REVIEW]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, the campaign will be closed immediately',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'warning'
      },
      confirm: {
        title: 'Done',
        text: 'The campaign has stopped'
      }
    }
  },
  activation: {
    [campaignActivationStatus.ACTIVATED]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, the campaign will be activated',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'warning'
      },
      confirm: {
        title: 'Done',
        text: 'The campaign has been activated'
      }
    },
    [campaignActivationStatus.DEACTIVATED]: {
      confirmation: {
        title: 'Are you sure?',
        text: 'Upon confirmation, the campaign will be deactivated',
        confirmText: 'I agree',
        cancelText: 'Cancel',
        type: 'warning'
      },
      confirm: {
        title: 'Done',
        text: 'The campaign has been deactivated'
      }
    }
  },
  termsAndCondition: {
    title: 'Terms & Conditions',
    html: `
      <ol class="text-left body-1">
        <li>Parties hereby agree that the guaranteed deliverables will no longer be a deliverable should the client decide to select influencers out of Kobe's AI technology system.</li>
        <li>Post will not include any direct sales (eg product code promotion) or client link in bio unless otherwise agreed.</li>
        <li>Content creator will only do 1 shoot based on brief approved by client and has full creative rights to the final execution of the post. Drafts will be sent to clients for the purpose of fact-checking. Stylistic changes are not allowed. Clients will be entitled to one revision.</li>
      </ol>`,
    confirmButtonText: 'Agree',
    cancelButtonText: 'Disagree'
  },
  pairingTermsAndCondition: {
    title: 'Terms & Conditions',
    html: `
      <ol class="text-left body-1">
        <li>You will be able to eliminate 20% of this list</li>
        <li>Please avoid any subjective biasness during this process</li>
        <li>Influencers have been screened and paired according to your brief requirements and their social data</li>
        <li>Influencers are not confirmed, they will be invited after you have given your approval</li>
        <li>Influencers will then decide if they would like to accept/reject this campaign</li>
        <li>In situations where there are high rejection rates from influencer, a new list will be added</li>
        <li>Please provide reason for elimination to facilitate our pairing process, if any</li>
      </ol>`,
    confirmButtonText: 'Agree',
    cancelButtonText: 'Disagree'
  },
  influencerContractTermsAndCondition: {
    title: 'Terms and Conditions',
    html: `
      <ol>
        <li>I have read and accepted the terms of use.</li>
        <li>I have read and understood supporting campaign details that accompany this brief.</li>
        <li>I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.</li>
        <li>I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.</li>
        <li>I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.</li>
        <li>I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.</li>
        <li>Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline.</li>
        <li>I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.</li>
        <li>I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.</li>
        <li>The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.</li>
      </ol>`,
    confirmButtonText: 'Accept',
    cancelButtonText: 'Decline'
  },
  confirmPayout: {
    title: 'Confirm!',
    html: `<p style="font-weight:600">Are you sure you want to confirm payout?</p>
    <p style="font-weight:600">After payout is confirmed the status will be changed to Sent and payment status will be changed to Processing.</p>`,
    htmlAOK: `<p style="font-weight:600">Are you sure you want to confirm payout?</p>
    <p style="font-weight:600">After payout is confirmed the status will be changed to Sent and payment status will be changed to Processing.</p>`,
    confirmButtonText: 'Confirm'
  },
  cancelPayout: {
    title: 'Cancel!',
    html: `<p style="font-weight:600">Are you sure you want to cancel payout?</p>
    <p style="font-weight:600">Please provide reason for this cancellation, admin will be notified of this request</p>
    <textarea class="form-control" style="color: black;font-size: 16px;font-weight: 500;" id="cancel-payout-reason" rows="3"></textarea>`,
    confirmButtonText: 'Confirm'
  }
}

const pairingBriefConfirmation = {
  approval: {
    confirmation: {
      title: 'Are you sure?',
      text: 'By pressing agree, you agree to participate in the campaign and acknowledge that you have read and agree with the terms and conditions stated in http://getkobe.com/influencer-terms-use-agreement/  ',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'You have agreed with our terms and conditions and agree to participate in the campaign. The campaign can now be viewed under the "Ongoing Campaigns" tab'
    }
  },
  rejection: {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, your participation in the campaign will be rejected',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'We are sad to see you reject the campaign',
      text: 'Hope you will participate in our campaigns in the future'
    }
  }
}

const rateCardConfirmation = {
  approval: {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the requested rate card will be applied',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'The requested rate card has been approved'
    }
  },
  rejection: {
    confirmation: {
      title: 'Are you sure?',
      text: 'Upon confirmation, the requested rate card will be rejected',
      confirmText: 'I agree',
      cancelText: 'Cancel',
      type: 'question'
    },
    confirm: {
      title: 'Success',
      text: 'The requested rate card has been rejected'
    }
  }
}

const paymentConsConfirmation = {
  unregisteredPrompt: (username) => {
    return {
      title: '',
      html: `The Influencer <b>${username}</b> don't have an account on IMS. Please invite the influencer to register on IMS.
      For any further assistants, contact here (<a href='https://kobe-r021324.slack.com/archives/C01CKH1LYAK' target='_blank'>https://kobe-r021324.slack.com/archives/C01CKH1LYAK</a>).`,
      confirmButtonText: 'OK'
    }
  }
}

const campaignModelSections = [
  {
    type: campaignModelSectionType.CAMPAIGN_SUMMARY,
    unreadComments: [],
    title: 'Campaign Summary',
    content: [
      {
        name: 'name',
        label: 'Campaign name',
        type: 'select',
        placeholder: 'Enter campaign name',
        value: [],
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Campaign name is required'
          }
        ]
      },
      {
        name: 'goal',
        label: 'Objective',
        type: 'combobox',
        placeholder: 'Enter campaign objective',
        items: [
          'Brand Awareness',
          'Branding',
          'Positioning',
          'Conversation',
          'Brand Loyalty'
        ],
        validations: []
      },
      {
        name: 'uniqueAdvantage',
        label: 'Unique Advantage',
        type: 'textarea',
        placeholder: 'Enter unique advantage',
        validations: []
      },
      {
        name: 'commonObjective',
        label: 'Common Objections',
        type: 'textarea',
        placeholder: 'Enter common objections',
        validations: []
      },
      {
        name: 'campaignType',
        label: 'Campaign Type',
        type: 'select',
        value: campaignTypeDisplay,
        defaultValue: campaignType.NO_PREFERENCE,
        placeholder: 'Campaign Type',
        validations: []
      },
      {
        name: 'targetAge',
        label: 'Target Audience - Age',
        type: 'combobox',
        items: targetAudienceDisplay.AGE,
        defaultValue: targetAudience.AGE.GROUP_C,
        placeholder: 'Target Audience Age Group',
        validations: []
      },
      {
        name: 'targetGender',
        label: 'Target Audience - Gender',
        type: 'select',
        value: targetAudienceDisplay.GENDER,
        defaultValue: targetAudience.GENDER.NO_PREFERENCE,
        placeholder: 'No preference',
        validations: []
      },
      {
        name: 'targetLocation',
        label: 'Target Audience - Location',
        type: 'combobox',
        value: targetAudienceDisplay.LOCATION,
        defaultValue: targetAudience.LOCATION.NO_PREFERENCE,
        placeholder: 'Country',
        validations: []
      },
      {
        name: 'platform',
        label: 'Platform',
        type: 'combobox',
        items: targetAudienceDisplay.PLATFORM,
        defaultValue: '',
        placeholder: 'No preference',
        validations: []
      },
      {
        name: 'dont',
        label: `Dont's`,
        type: 'text',
        placeholder: '',
        validations: []
      },
      // Nyein Aung - commented out this to rollback if needed
      // {
      //   name: 'visualMust',
      //   label: 'Visual must-haves',
      //   type: 'textarea',
      //   placeholder: '',
      //   validations: []
      // },
      // {
      //   name: 'copyMust',
      //   label: 'Copy must-haves',
      //   type: 'textarea',
      //   placeholder: '',
      //   validations: []
      // },
      {
        name: 'campaignBackground',
        label: 'Campaign background',
        type: 'textarea',
        placeholder: '',
        validations: []
      },
      {
        name: 'vertical',
        label: 'Campaign Vertical',
        type: 'text',
        placeholder: 'Enter Campaign Vertical',
        validations: []
      },
      {
        name: 'kic',
        label: `Kobe Influencer Canvas`,
        type: 'upload',
        placeholder: '',
        validations: []
      },
      {
        name: 'callToActionLinks',
        label: 'Call-To-Action Links',
        type: 'textarea',
        placeholder: '(i.e UTM, Promo Codes)',
        validations: []
      },
      {
        name: 'mechanics',
        label: 'Mechanics',
        type: 'textarea',
        placeholder: '',
        validations: []
      }
    ]
  },
  // {
  //   type: campaignModelSectionType.CAMPAIGN_SUMMARY_2,
  //   unreadComments: [],
  //   title: 'Campaign Summary 2',
  //   content: [
  //     {
  //       name: 'product_name',
  //       label: 'Your product',
  //       type: 'text',
  //       placeholder: 'Describe your product features, benefits',
  //       validations: [
  //         {
  //           name: 'required',
  //           value: required,
  //           message: 'Product Name is required'
  //         }
  //       ]
  //     },
  //     {
  //       name: 'marketing_messages',
  //       label: 'Marketing messages',
  //       type: 'textarea',
  //       placeholder: 'Describe your product value proposition and unique competitive advantage',
  //       validations: [
  //         {
  //           name: 'required',
  //           value: required,
  //           message: 'Marketing Messages name is required'
  //         }
  //       ]
  //     },
  //     {
  //       name: 'distribution_channels',
  //       label: 'Channels of distribution',
  //       type: 'text',
  //       placeholder: 'Enter channels of distribution',
  //       validations: [
  //         {
  //           name: 'required',
  //           value: required,
  //           message: 'Channels of distribution is required'
  //         }
  //       ]
  //     },
  //     {
  //       name: 'pricing_strategy',
  //       label: 'Pricing strategy',
  //       type: 'text',
  //       placeholder: 'Enter pricing strategy',
  //       validations: [
  //         {
  //           name: 'required',
  //           value: required,
  //           message: 'Pricing strategy is required'
  //         }
  //       ]
  //     }
  //   ]
  // },
  {
    type: campaignModelSectionType.CONTENT_ANGLE,
    unreadComments: [],
    title: 'Concept',
    content: [
      {
        name: 'angles',
        label: 'Concept',
        type: 'multiple_options',
        template: [
          {
            name: 'option_name',
            label: 'Option Name',
            type: 'text',
            placeholder: 'Name Your option',
            validations: []
          },
          {
            name: 'context',
            label: 'Campaign Context',
            type: 'textarea',
            placeholder: 'Enter angle required action',
            validations: []
          },
          {
            name: 'formats',
            label: 'Add More Format',
            type: 'multiple_options',
            template: [
              [
                {
                  name: 'required_action',
                  label: 'Required action',
                  type: 'textarea',
                  placeholder: 'Enter angle required action',
                  validations: []
                },
                {
                  name: 'sample_images',
                  label: 'Image inspiration',
                  type: 'upload',
                  validations: []
                },
                {
                  name: 'image_angle',
                  label: 'Image/Video Pointers',
                  type: 'textarea',
                  placeholder: 'Enter image/video pointers',
                  validations: []
                },
                {
                  name: 'remark',
                  label: 'Remarks',
                  type: 'textarea',
                  placeholder: 'Remarks',
                  validations: []
                },
                {
                  name: 'content_angle',
                  label: 'Content Pointers',
                  type: 'textarea',
                  placeholder: 'Enter content pointers',
                  validations: []
                },
                {
                  name: 'mandatory',
                  label: 'Mandatory Hashtags and Mentions',
                  type: 'combobox',
                  items: [],
                  defaultValue: '',
                  placeholder: 'Enter Mandatory Hashtags and Mentions',
                  validations: []
                }
              ]
            ]
          }
        ],
        validations: []
      },
      // action required options should not visible for clients
      {
        name: 'actionRequired_time',
        label: 'Action required - Time',
        type: 'select',
        value: actionRequiredDisplay.TIME,
        defaultValue: actionRequired.TIME.LESS_1_HOUR,
        placeholder: 'No preference',
        validations: []
      },
      {
        name: 'actionRequired_action',
        label: 'Action required - Action',
        type: 'select',
        value: actionRequiredDisplay.ACTION,
        defaultValue: actionRequired.ACTION.RECEIVE,
        placeholder: 'No preference',
        validations: []
      },
      {
        name: 'actionRequired_receive',
        label: 'Action required - Receive',
        type: 'select',
        value: actionRequiredDisplay.RECEIVE,
        defaultValue: actionRequired.RECEIVE.NA,
        placeholder: 'No preference',
        validations: []
      },
      {
        name: 'actionRequired_value',
        label: 'Action required - Value',
        type: 'select',
        value: actionRequiredDisplay.VALUE,
        defaultValue: actionRequired.VALUE.NA,
        placeholder: 'No preference',
        validations: []
      }
    ]
  },
  {
    type: campaignModelSectionType.INFLUENCER_SELECTION,
    unreadComments: [],
    title: 'Creator Profiling',
    content: [
      {
        name: 'influencer_min_age',
        label: 'Creator Age From',
        type: 'text',
        placeholder: "Enter influencer's minimum age",
        validations: [
          {
            name: 'numeric',
            value: numeric,
            message: 'Minimum influencer must be a number'
          }
        ]
      },
      {
        name: 'influencer_max_age',
        label: 'Creator Age To',
        type: 'text',
        placeholder: "Enter influencer's maximum age",
        validations: [
          {
            name: 'numeric',
            value: numeric,
            message: 'Maximum influencer must be a number'
          }
        ]
      },
      {
        name: 'influencer_ideal',
        label: 'I would like',
        type: 'combobox',
        items: [],
        placeholder: 'Enter desired attributes',
        validations: []
      },
      {
        name: 'influencer_unwanted',
        label: "I don't want",
        type: 'combobox',
        items: [],
        placeholder: 'Enter undesirable attributes',
        validations: []
      },
      {
        name: 'gender',
        label: 'Creator Gender',
        type: 'select',
        value: userGenderDisplay,
        defaultValue: userGenders.BOTH,
        placeholder: 'No preference',
        validations: []
      },
      {
        name: 'segment',
        label: 'Creator Segmentation Preference',
        type: 'chips',
        value: userSegmentDisplay,
        placeholder: 'No preference',
        validations: []
      }
    ]
  },
  {
    type: campaignModelSectionType.VIDEO_BRIEF,
    unreadComments: [],
    title: 'Video Brief',
    content: [
      {
        name: 'content_creator',
        label: 'Content Creator(s)',
        type: 'text',
        placeholder: 'Enter Content Creator',
        validations: []
      },
      {
        name: 'video_live_date',
        label: 'Video Live Date',
        type: 'date',
        placeholder: 'Enter Video Live Date',
        validations: []
      },
      {
        name: 'end_video_link',
        label: 'Links To Include at End of Video',
        type: 'textarea',
        placeholder: 'Company website or landing page',
        validations: []
      },
      {
        name: 'video_objective',
        label: 'Video Objective',
        type: 'textarea',
        placeholder: 'E.g. highlight USP of product',
        validations: []
      },
      {
        name: 'branded_mentions',
        label: 'Branded Mentions',
        type: 'textarea',
        placeholder: 'Spelling & pronunciation of Brand/Product Name to be used',
        validations: []
      },
      {
        name: 'video_storyboard',
        label: 'Video Storyboard',
        type: 'textarea',
        placeholder: 'Brief storyline of video',
        validations: []
      },
      {
        name: 'preferred_video',
        label: 'Preferred video background/location/setting',
        type: 'textarea',
        placeholder: '...',
        validations: []
      },
      {
        name: 'others',
        label: 'Others',
        type: 'textarea',
        placeholder: 'Video Dimension, Sound and Light requirements',
        validations: []
      },
      {
        name: 'tags',
        label: 'Hashtags, Location Check-in (0r) Tag Requirements',
        type: 'combobox',
        items: [],
        placeholder: '(up to 3)',
        validations: []
      },
      {
        name: 'suggested_video_length',
        label: 'Suggested Video Length',
        type: 'text',
        placeholder: 'Recommended all instagram posts to be below 45s',
        validations: []
      },
      {
        name: 'dos',
        label: 'Dos',
        type: 'combobox',
        items: [],
        placeholder: 'e.g. clothing of bloggers/talents',
        validations: []
      },
      {
        name: 'donts',
        label: `Dont's`,
        type: 'combobox',
        items: [],
        placeholder: 'e.g. clothing of bloggers/talents',
        validations: []
      }
    ]
  },
  {
    type: campaignModelSectionType.BUDGET_ALLOCATION,
    unreadComments: [],
    title: 'Budget Allocation',
    content: [
      {
        name: 'ioNumbers',
        label: 'IO Number',
        type: 'select',
        defaultValue: '',
        value: '',
        placeholder: 'IO Number',
        validations: []
      },
      {
        name: 'budget',
        label: 'Campaign budget',
        type: 'slider',
        placeholder: 'Enter campaign budget',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Campaign budget is required'
          },
          {
            name: 'numeric',
            value: numeric,
            message: 'Campaign budget must be a number'
          }
        ],
        showToClient: {
          name: 'showBudgetToClient',
          defaultValue: true,
          showText: 'Campaign budget is Visible for Clients',
          hideText: 'Campaign budget is Hidden for Clients'
        }
      },
      {
        name: 'outreach',
        label: 'Campaign outreach',
        type: 'slider',
        placeholder: 'Enter campaign outreach',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Campaign outreach is required'
          },
          {
            name: 'numeric',
            value: numeric,
            message: 'Campaign outreach must be a number'
          }
        ]
      },
      {
        name: 'engagement',
        label: 'Campaign engagement',
        type: 'slider',
        placeholder: 'Enter campaign engagement',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Campaign engagement is required'
          },
          {
            name: 'numeric',
            value: numeric,
            message: 'Campaign engagement must be a number'
          }
        ]
      },
      {
        name: 'min_content',
        label: 'Minimum content',
        type: 'text',
        placeholder: 'Enter campaign minimum content',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Minimum content is required'
          },
          {
            name: 'numeric',
            value: numeric,
            message: 'Minimum content must be a number'
          }
        ]
      },
      {
        name: 'max_content',
        label: 'Maximum content',
        type: 'text',
        placeholder: 'Enter campaign maxinimum content',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Maximum content is required'
          },
          {
            name: 'numeric',
            value: numeric,
            message: 'Maximum content must be a number'
          }
        ]
      },
      {
        name: 'kpi_onboarded',
        label: 'KPI Onboarded',
        type: 'text',
        placeholder: 'Enter KPI Onboarded',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'KPI Onboarded is required'
          },
          {
            name: 'numeric',
            value: numeric,
            message: 'KPI Onboarded must be a number'
          }
        ]
      },
      {
        name: 'startDate',
        label: 'Start Month',
        type: 'date',
        placeholder: 'Enter campaign start month',
        validations: []
      },
      {
        name: 'endDate',
        label: 'End Month',
        type: 'date',
        placeholder: 'Enter campaign end month',
        validations: []
      },
      {
        name: 'revenueCalculation',
        label: 'Revenue Calculations',
        type: 'radio',
        defaultValue: 'content',
        placeholder: '',
        validations: []
      }
    ]
  },
  {
    type: campaignModelSectionType.EVENT_BRIEF,
    unreadComments: [],
    title: 'Event Brief',
    content: [
      {
        name: 'eventAttendees',
        label: 'Event Attendees',
        type: 'multiple_options',
        template: [
          {
            name: 'attendeeName',
            label: 'Attendee Name',
            type: 'text',
            placeholder: '',
            validations: []
          },
          {
            name: 'attendeeDesignation',
            label: 'Designation',
            type: 'text',
            placeholder: '',
            validations: []
          },
          {
            name: 'attendeeRole',
            label: 'Role',
            type: 'text',
            placeholder: '',
            validations: []
          },
          {
            name: 'attendeeContactNumber',
            label: 'Contact Number',
            type: 'text',
            placeholder: '',
            validations: []
          }
        ],
        validations: []
      },
      {
        name: 'eventRunDown',
        label: 'Event Run Down',
        type: 'template',
        template: [
          {
            name: 'isFoodProvided',
            label: 'Will food and drinks be provided during the event?',
            type: 'radioButton',
            validations: []
          },
          {
            name: 'isRequireDietary',
            label: 'Do you require the influencer to specify their dietary requirements?',
            type: 'radioButton',
            validations: []
          },
          {
            name: 'isGuided',
            label: 'Is this a guided event?',
            type: 'radioButton',
            validations: []
          },
          {
            name: 'eventDate',
            label: 'Event Date',
            type: 'date',
            validations: []
          },
          {
            name: 'eventStartTime',
            label: 'Start Time',
            type: 'text',
            validations: []
          },
          {
            name: 'eventEndTime',
            label: 'End Time',
            type: 'text',
            validations: []
          },
          {
            name: 'eventSchedule',
            label: 'Schedule (if any)',
            type: 'textarea',
            validations: []
          }
        ],
        validations: []
      },
      {
        name: 'additionalGifts',
        label: 'Additional Gifts',
        type: 'template',
        template: [
          {
            name: 'isIncludeGifts',
            label: 'Will there be any gifts prepared for the influencers?',
            type: 'radioButton',
            validations: []
          },
          {
            name: 'giftForPaidInfluencers',
            label: 'Gift for Paid Influencers',
            type: 'textarea',
            placeholder: 'Customized PR kit for influencer',
            validations: []
          },
          {
            name: 'giftForUnpaidInfluencers',
            label: 'Gift for Unpaid Influencers',
            type: 'textarea',
            placeholder: 'PR Kit for unpaid influencers',
            validations: []
          }
        ],
        validations: []
      },
      {
        name: 'specialInstructions',
        label: 'Special Instructions (If Any)',
        type: 'textarea',
        placeholder: `
        - Kobe to run through program notes and conduct guided tour
        - PR Kit must be featured in IG story at least once`,
        validations: []
      }
    ]
  }
]

const pairingBriefModelSections = [
  {
    type: pairingBriefModelSectionType.CAMPAIGN_SUMMARY,
    unreadComments: [],
    title: 'Pairing Brief Summary (Initial email to influencer)',
    content: [
      {
        name: 'pairing_brief_client',
        label: 'Client',
        type: 'textarea',
        placeholder: '(Briefly provide the industry and what the client does) Example: A leading beauty brand that is trending amongst millennials',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Client details are required'
          }
        ]
      },
      {
        name: 'pairing_brief_product',
        label: 'Product',
        type: 'textarea',
        placeholder: '(Insert main USP) Example: Latest lipstick that lasts more than 48 hours',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Campaign goal is required'
          }
        ]
      },
      {
        name: 'pairing_brief_background',
        label: 'Background',
        type: 'textarea',
        placeholder: 'Briefly describes why the client does what its doing and why the specific product is being focused for this campaign. Example: A home name in the beauty industry, our client has expertise in understanding the different needs and demands of women and is determined to make every woman feel confident of themselves. Their new product, a long lasting lipstick range, helps to strengthen every woman’s confidence by allowing them to go from work to play without worrying on their looks!',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Campaign outreach is required'
          }
        ]
      },
      {
        name: 'pairing_brief_objective',
        label: 'Objective',
        type: 'textarea',
        placeholder: 'Share the main points and objectives the client wishes to achieve out of this campaign. Example:  To reach out and be top of mind amongst the millennials when it comes to beauty products',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Campaign engagement is required'
          }
        ]
      },
      {
        name: 'pairing_brief_actions',
        label: 'Actions',
        type: 'textarea',
        placeholder: 'Briefly describe what the influencer has to do and touch on overarching messaging of content. Example: Head down to Kobe HQ to collect the product. Experience the product in your normal routine. Share your thoughts on the experience of the product and the impact on your daily activities',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Actions is required'
          }
        ]
      },
      {
        name: 'pairing_brief_deadline',
        label: 'Deadline',
        type: 'textarea',
        placeholder: 'Provide exact date for submission if possible, or in the case of product delivery and it’s unforeseeable on the delivery date, provide 3-4 days for influencer to submit their drafts ***Always provide 2359 hours so that the influencer will be able to submit within the deadline date. Example: 30th September 2018, 2359 hours OR Within 4 days of receiving the product, 2359 hours',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Date is required'
          }
        ]
      },
      {
        name: 'pairing_brief_deliverables',
        label: 'Deliverables',
        type: 'textarea',
        placeholder: 'Provide exactly what the influencer has to do in terms of the posting or IG story. Example: 1 X IG multi photo posting (minimally 2 images and one of the image to include product in it)',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Deliverables is required'
          }
        ]
      }
    ]
  },
  {
    type: pairingBriefModelSectionType.CAMPAIGN_DETAILS,
    unreadComments: [],
    title: 'Pairing Brief Details (Influencer has accepted)',
    content: [
      {
        name: 'pairing_brief_client_name',
        label: 'Client Name',
        type: 'text',
        placeholder: 'Enter client name',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Client name is required'
          }
        ]
      },
      {
        name: 'pairing_brief_client_background',
        label: 'Client Background',
        type: 'textarea',
        placeholder: 'Describe your client background',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Client background is required'
          }
        ]
      },
      {
        name: 'pairing_brief_required_actions',
        label: 'Required Actions',
        type: 'textarea',
        placeholder: 'Actions required',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Actions is required'
          }
        ]
      },
      {
        name: 'pairing_brief_image_angle',
        label: 'Image Angle',
        type: 'textarea',
        placeholder: 'Enter image angle'
      },
      {
        name: 'pairing_brief_content_angle',
        label: 'Content Angle',
        type: 'textarea',
        placeholder: 'Enter content angle'
      },
      {
        name: 'pairing_brief_draft_deadline',
        label: 'Draft Deadline',
        type: 'textarea',
        placeholder: 'Deadline required',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Deadline is required'
          }
        ]
      },
      {
        name: 'pairing_brief_hashtags',
        label: 'Hashtags to be used',
        type: 'textarea',
        placeholder: 'Hashtags required',
        validations: [
          {
            name: 'required',
            value: required,
            message: 'Hashtags are required'
          }
        ]
      }
    ]
  }
]

const brandSheetFormSections = {
  sectionOne: {
    title: 'SECTION ONE: MARKETING ASSESSMENT',
    subtitle: 'CLIENT CONTACT DETAILS',
    name: 'sectionOne',
    required: true,
    fields: [
      {
        label: 'First name',
        name: 'firstName',
        type: 'textbox',
        required: true,
        class: 'xs12 md6 pr-5'
      },
      {
        label: 'Last name',
        name: 'lastName',
        type: 'textbox',
        required: true
      },
      {
        label: 'Job Title',
        name: 'jobTitle',
        type: 'textbox',
        required: true,
        class: 'xs12 md12'
      },
      {
        label: 'Organisation',
        name: 'organization',
        type: 'textbox',
        required: true,
        class: 'xs12 md12'
      },
      {
        label: 'Mobile No',
        name: 'mobileCountry',
        type: 'select',
        class: 'xs12 md4',
        required: true,
        defaultOptions: dialCodes.map(d => d.cn)
      },
      {
        label: '',
        name: 'mobilePhone',
        type: 'textbox',
        class: 'xs12 md8'
      },
      {
        label: 'Email',
        name: 'email',
        type: 'textbox',
        class: 'xs12 md6 pr-5',
        required: true
      },
      {
        label: 'KOBE POC',
        name: 'kobePoc',
        type: 'textbox',
        class: 'xs12 md6',
        required: true
      },
      {
        label: 'Company Background',
        name: 'companyBackground',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Background of the Brand (Limit to 100 words)',
        required: true
      },
      {
        label: 'Competitive Background',
        name: 'competitiveBackground',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'List some of your competitors',
        required: true
      }
    ]
  },
  sectionTwo: {
    title: 'SECTION TWO: ADVERTISER OBJECTIVES',
    name: 'sectionTwo',
    required: true,
    fields: [
      {
        label: 'Project Title',
        name: 'projectTitle',
        type: 'textbox',
        hint: `ProductName/CampaignName-CampaignPeriod(QxYY)-Markets (SG,MY,TH,ID,PH,VN)<br>
        E.g. CocaColaVanilaLaunch-Q223-SGMY<br>`,
        class: 'xs12 md12'
      },
      {
        label: 'Product Details',
        name: 'productDetails',
        type: 'textarea',
        hint: `What is the featured product/service?<br>
        Distribution channels<br>
        How has this product been marketed to your audiences?`,
        class: 'xs12 md12'
      },
      {
        label: 'Campaign Objectives',
        name: 'campaignObjective',
        type: 'textarea',
        hint: `1. What are you trying to achieve?<br>
        2. Describe how the project's success will be measured`,
        class: 'xs12 md12'
      },
      {
        label: 'Key Message',
        name: 'keyMessage',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'What do you want the audience to remember from this campaign?'
      },
      {
        label: 'Key Barriers',
        name: 'keyBarriers',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'What are your marketing challenges?'
      },
      {
        label: 'Campaign Timeframe',
        name: 'campaignTimeframe',
        type: 'textbox',
        class: 'xs12 md12',
        hint: 'State preferred start date',
        placeholder: 'Eg. Jan 2022'
      },
      {
        label: 'Campaign Duration',
        name: 'campaignDuration',
        type: 'textbox',
        class: 'xs12 md12',
        hint: 'How long will this campaign run for?',
        placeholder: 'Eg. 1 month, 3 months, etc.'
      },
      {
        label: 'Campaign Budget',
        name: 'campaignBudget',
        type: 'textbox',
        class: 'xs12 md12',
        hint: 'Please choose the currency for budget.',
        placeholder: '',
        numberText: true,
        required: true
      }
    ]
  },
  sectionThree: {
    title: 'SECTION THREE: AUDIENCE AND CREATORS PROFILING',
    name: 'sectionThree',
    required: true,
    fields: [
      {
        label: 'Age',
        name: 'age',
        type: 'checkbox',
        class: 'xs12 md12',
        hint: 'What is your target audience’s age? - Select up to 2',
        detailFields: [
          {
            label: 'Teenagers (13-17)',
            value: 'teenagers'
          },
          {
            label: 'Young Adults (18 - 24)',
            value: 'youngAdults'
          },
          {
            label: 'Executives (25-34)',
            value: 'executives'
          },
          {
            label: 'Others (35+)',
            value: 'others'
          }
        ]
      },
      {
        label: 'Gender',
        name: 'gender',
        type: 'select',
        class: 'xs12 md12',
        hint: `What is your target audience's gender?`,
        placeholder: 'Male / Female / Both',
        defaultOptions: userGenderDisplay
      },
      {
        label: 'Key Insights',
        name: 'keyInsights',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Industry or audience insights that may be helpful for us to understand your audience more'
      },
      {
        label: 'I Would Like',
        name: 'wouldLike',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Enter as many keywords that describe your ideal audience'
      },
      {
        label: `I Don't Want`,
        name: 'dontWant',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Help us EXCLUDE audience with these keywords'
      },
      {
        label: `Hashtags, Location Check-in, or Tag Requirements`,
        name: 'hashTags',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'List up to 3'
      },
      {
        label: `Creators Look-alikes`,
        name: 'lookAlike',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Creators you have worked with in the past / Creators you are currently working with'
      },
      {
        label: `Additional Information (if any)`,
        name: 'additionalInfo',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Any reference links or additional information you would like us to know'
      },
      {
        label: `Attach Marketing Collaterals (if any)`,
        name: 'marketingCollaterals',
        type: 'file',
        class: 'xs12 md12'
      }
    ]
  }
}
const brandSheetAOKFormSections = {
  sectionOne: {
    title: 'KOBE Uncut GUIDELINES',
    subtitle: 'KOBE Uncut PROCESS',
    name: 'sectionOne',
    required: true,
    fields: [
      {
        label: 'Brand (& Agency)',
        name: 'brandAgency',
        type: 'textbox',
        class: 'xs12 md12',
        // hint: 'List some of your competitors',
        required: true
      },
      {
        label: 'Email',
        name: 'email',
        type: 'textbox',
        class: 'xs12 md12',
        required: true
      },
      {
        label: 'Campaign Name',
        name: 'campaignName',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'Original Dry Shampoo',
        required: true
      },
      {
        label: 'Campaign Period',
        name: 'campaignPeriod',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'June 2020 - July 2020',
        required: true
      },
      {
        label: 'Campaign Duration',
        name: 'campaignDuration',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'Eg. 3 Months or 6 Months',
        required: true
      },
      {
        label: 'Brand Information',
        name: 'brandInformation',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Background of the Brand (Limit to 100 words)',
        placeholder: `UK's No 1 Dry Shampoo with a classic fragrance`,
        required: true
      },
      {
        label: 'Key Message',
        name: 'keyMessage',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `1. Key message of how your product/service stands out to consumers<br>2. USPs: The Unique Selling Points of your product/service`,
        placeholder: `Educating consumers on a great alternative to shampooing your hair with Batiste Dry Shampoo. No time to wash your hair? Batiste Dry Shampoo is an innovative formula that boosts the body and helps eliminate oily roots, giving dull lifeless hair an instant makeover without water. A quick spray revitalizes hair leaving it looking and feeling clean, no drama.  It's not magic, it's science! Dry shampoo is a waterless formula that absorbs dirt and oil from the scalp giving your hair that just washed feeling. Or as we like to call it, the reason you can hit snooze in the morning.`,
        required: true
      },
      {
        label: 'Product/Service Information',
        name: 'productInformation',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `Details of product/service<br>
        Specific copy of Brand name<br>
        Link to website (if any)`,
        placeholder: `Place of Origin: United Kingdom Ingredients: Butane, Isobutane, Propane, Oryza Sativa (Rice) Starch, Alcohol Denat., Parfum (Fragrance), Limonene, Linalool, Geraniol, Benzyl Benzoate, Distearyldimonium Chloride, Centrimonium Chloride. https://www.batistehair.com/`,
        required: true
      },
      {
        label: 'USPs',
        name: 'USP',
        type: 'textbox',
        class: 'xs12 md12',
        hint: `The Unique Selling Points of your product/service`,
        placeholder: `1. Waterless Formula   2. Fuss-Free Quick Spray`,
        required: true
      },
      {
        label: 'Pricing',
        name: 'pricing',
        type: 'textbox',
        class: 'xs12 md12',
        hint: `How much is this product/service priced?`,
        placeholder: `$8.99`,
        required: true
      },
      {
        label: 'Direction for use',
        name: 'directionUse',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `(If any)`,
        placeholder: `Shake well. Hold can 30cm from dry hair, section and spray onto roots. Go lightly at first, adding more as and when you need it. Give your roots a massage to add some volume and get rid of any excess oil. Brush through to remove excess residue and style as usual. Et Voila! Ready for whatever, with gorgeous refreshed hair.`
      },
      {
        label: 'Logistic Arrangement',
        name: 'LogisticArrangement',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `Product/Service Each Creator will receive:<br>
        Date of Logistics:<br>
        Logistics Preference: (client/KOBE)<br>
        Quantity of Product:`,
        placeholder: ``
      },
      {
        label: 'Hashtag or Mentions (up to 3 Hashtags)',
        name: 'hashTags',
        type: 'textarea',
        class: 'xs12 md12',
        placeholder: ``
      },
      {
        label: `Attach Marketing Collaterals (if any)`,
        name: 'marketingCollaterals',
        type: 'file',
        class: 'xs12 md12'
      }
    ]
  }
}

const brandSheetKobeLiteFormSections = {
  sectionOne: {
    title: 'KOBE Lite GUIDELINES',
    subtitle: 'AOK PROCESS',
    name: 'sectionOne',
    required: true,
    fields: [
      {
        label: 'Brand (& Agency)',
        name: 'brandAgency',
        type: 'textbox',
        class: 'xs12 md12',
        // hint: 'List some of your competitors',
        required: true
      },
      {
        label: 'Email',
        name: 'email',
        type: 'textbox',
        class: 'xs12 md12',
        required: true
      },
      {
        label: 'Campaign Name',
        name: 'campaignName',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'Original Dry Shampoo',
        required: true
      },
      {
        label: 'Campaign Period',
        name: 'campaignPeriod',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'June 2020 - July 2020',
        required: true
      },
      {
        label: 'Campaign Duration',
        name: 'campaignDuration',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'Eg. 6 Months',
        required: true
      },
      {
        label: 'Brand Information',
        name: 'brandInformation',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Background of the Brand (Limit to 100 words)',
        placeholder: `UK's No 1 Dry Shampoo with a classic fragrance`,
        required: true
      },
      {
        label: 'Key Message',
        name: 'keyMessage',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `1. Key message of how your product/service stands out to consumers<br>2. USPs: The Unique Selling Points of your product/service`,
        placeholder: `Educating consumers on a great alternative to shampooing your hair with Batiste Dry Shampoo. No time to wash your hair? Batiste Dry Shampoo is an innovative formula that boosts the body and helps eliminate oily roots, giving dull lifeless hair an instant makeover without water. A quick spray revitalizes hair leaving it looking and feeling clean, no drama.  It's not magic, it's science! Dry shampoo is a waterless formula that absorbs dirt and oil from the scalp giving your hair that just washed feeling. Or as we like to call it, the reason you can hit snooze in the morning.`,
        required: true
      },
      {
        label: 'Product/Service Information',
        name: 'productInformation',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `Details of product/service<br>
        Specific copy of Brand name<br>
        Link to website (if any)`,
        placeholder: `Place of Origin: United Kingdom Ingredients: Butane, Isobutane, Propane, Oryza Sativa (Rice) Starch, Alcohol Denat., Parfum (Fragrance), Limonene, Linalool, Geraniol, Benzyl Benzoate, Distearyldimonium Chloride, Centrimonium Chloride. https://www.batistehair.com/`,
        required: true
      },
      {
        label: 'USPs',
        name: 'USP',
        type: 'textbox',
        class: 'xs12 md12',
        hint: `The Unique Selling Points of your product/service`,
        placeholder: `1. Waterless Formula   2. Fuss-Free Quick Spray`,
        required: true
      },
      {
        label: 'Pricing',
        name: 'pricing',
        type: 'textbox',
        class: 'xs12 md12',
        hint: `How much is this product/service priced?`,
        placeholder: `$8.99`,
        required: true
      },
      {
        label: 'Direction for use',
        name: 'directionUse',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `(If any)`,
        placeholder: `Shake well. Hold can 30cm from dry hair, section and spray onto roots. Go lightly at first, adding more as and when you need it. Give your roots a massage to add some volume and get rid of any excess oil. Brush through to remove excess residue and style as usual. Et Voila! Ready for whatever, with gorgeous refreshed hair.`
      },
      {
        label: 'Logistic Arrangement',
        name: 'LogisticArrangement',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `Product/Service Each Creator will receive:<br>
        Date of Logistics:<br>
        Logistics Preference: (client/KOBE)<br>
        Quantity of Product:`,
        placeholder: ``
      },
      {
        label: 'Hashtag or Mentions (up to 3 Hashtags)',
        name: 'hashTags',
        type: 'textarea',
        class: 'xs12 md12',
        placeholder: ``
      },
      {
        label: `Attach Marketing Collaterals (if any)`,
        name: 'marketingCollaterals',
        type: 'file',
        class: 'xs12 md12'
      }
    ]
  }
}

const brandSheetUGCFormSections = {
  sectionOne: {
    title: 'AOK GUIDELINES',
    subtitle: 'AOK PROCESS',
    name: 'sectionOne',
    required: true,
    fields: [
      {
        label: 'Brand (& Agency)',
        name: 'brandAgency',
        type: 'textbox',
        class: 'xs12 md12',
        // hint: 'List some of your competitors',
        required: true
      },
      {
        label: 'Email',
        name: 'email',
        type: 'textbox',
        class: 'xs12 md12',
        required: true
      },
      {
        label: 'Campaign Name',
        name: 'campaignName',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'Original Dry Shampoo',
        required: true
      },
      {
        label: 'Start Date',
        name: 'startDate',
        type: 'textbox',
        class: 'xs12 md12',
        placeholder: 'dd/mm/yyyy',
        required: true
      },
      {
        label: 'Brand Information',
        name: 'brandInformation',
        type: 'textarea',
        class: 'xs12 md12',
        hint: 'Background of the Brand (Limit to 100 words)',
        placeholder: `UK's No 1 Dry Shampoo with a classic fragrance`,
        required: true
      },
      {
        label: 'Key Message',
        name: 'keyMessage',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `1. Key message of how your product/service stands out to consumers<br>2. USPs: The Unique Selling Points of your product/service`,
        placeholder: `Educating consumers on a great alternative to shampooing your hair with Batiste Dry Shampoo. No time to wash your hair? Batiste Dry Shampoo is an innovative formula that boosts the body and helps eliminate oily roots, giving dull lifeless hair an instant makeover without water. A quick spray revitalizes hair leaving it looking and feeling clean, no drama.  It's not magic, it's science! Dry shampoo is a waterless formula that absorbs dirt and oil from the scalp giving your hair that just washed feeling. Or as we like to call it, the reason you can hit snooze in the morning.`,
        required: true
      },
      {
        label: 'Product/Service Information',
        name: 'productInformation',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `Details of product/service<br>
        Specific copy of Brand name<br>
        Link to website (if any)`,
        placeholder: `Place of Origin: United Kingdom Ingredients: Butane, Isobutane, Propane, Oryza Sativa (Rice) Starch, Alcohol Denat., Parfum (Fragrance), Limonene, Linalool, Geraniol, Benzyl Benzoate, Distearyldimonium Chloride, Centrimonium Chloride. https://www.batistehair.com/`,
        required: true
      },
      {
        label: 'How will you be providing your product or service experience ',
        name: 'productExperienceType',
        type: 'radio',
        class: 'xs12 md12',
        placeholder: `
        Deliver directly,
        Pick Up Point,
        Reimbursement Basis`
      },
      {
        label: 'Pricing',
        name: 'pricing',
        type: 'textbox',
        class: 'xs12 md12',
        hint: `How much is this product/service priced?`,
        placeholder: `$8.99`,
        required: true
      },
      {
        label: 'What will you like the creator to do to experience your product or service?',
        name: 'experiencesForCreators',
        type: 'textarea',
        class: 'xs12 md12',
        hint: ``,
        placeholder: `Head down to Jurong Point, spin the lucky draw and enjoy sure-win of $50 grabvouchers.
        Collect hair serum worth $25 from Joo Chiat.
        Visit CCK190 Wanton Mee to purchase wanton noodles from $4.`
      },
      {
        label: 'Exact Location and Transport Directions',
        name: 'locationAndDirections',
        type: 'textarea',
        class: 'xs12 md12',
        hint: ``,
        placeholder: `Blk 89 Circuit Rd, #01-110, Singapore 370089
        Nearest MRT: Macpherson MRT, public parking available within 2 mins walk.`
      },
      {
        label: 'Visiting Dates & Hour range',
        name: 'visitingRange',
        type: 'textarea',
        class: 'xs12 md12',
        hint: ``,
        placeholder: `Between 15 Oct to 15 Dec, 9am to 2pm
        Monday - Friday only`
      },
      {
        label: 'Direction for use',
        name: 'directionUse',
        type: 'textarea',
        class: 'xs12 md12',
        hint: `(If any)`,
        placeholder: `Shake well. Hold can 30cm from dry hair, section and spray onto roots. Go lightly at first, adding more as and when you need it. Give your roots a massage to add some volume and get rid of any excess oil. Brush through to remove excess residue and style as usual. Et Voila! Ready for whatever, with gorgeous refreshed hair.`
      },
      {
        label: 'Hashtag or Mentions (up to 3 Hashtags)',
        name: 'hashTags',
        type: 'textarea',
        class: 'xs12 md12',
        placeholder: ``
      },
      {
        label: `Sample Video Content for UGC creator’s reference:`,
        name: 'sampleVideoContent',
        type: 'custom',
        class: 'xs12 md12',
        placeholder: `Sample video url`
      },
      {
        label: `Attach Marketing Collaterals (if any)`,
        name: 'marketingCollaterals',
        type: 'custom',
        class: 'xs12 md12'
      }
    ]
  }
}

export default Object.assign(
  {},
  {
    campaignStatusFlow,
    pairingStatus,
    eliminationStatus,
    pairingStatusDisplay,
    payoutStatus,
    payoutStatusDisplay,
    campaignStatusDisplayForClients,
    postStatus,
    postStatusDisplay,
    clientPaymentStatus,
    clientPaymentStatusDisplay,
    queryType,
    campaignActivationStatus,
    campaignModelSections,
    campaignModelSectionType,
    pairingBriefModelSections,
    pairingBriefModelSectionType,
    campaignConfirmation,
    pairingBriefConfirmation,
    rateCardConfirmation,
    userSegmentDisplay,
    targetAudienceDisplay,
    campaignType,
    campaignTypeDisplay,
    campaignStage,
    campaignStageDisplay,
    pairingSendStatus,
    pairingSendStatusDisplay,
    brandSheetFormSections,
    brandSheetAOKFormSections,
    brandSheetKobeLiteFormSections,
    brandSheetUGCFormSections,
    userGenderDisplay,
    paymentStatus,
    imsStatuses,
    tableActions,
    paymentConsConfirmation,
    paymentConsExportTypes,
    paymentConsSectionIDs,
    dashboardStatuses,
    dashboardStatusDisplay,
    bfsTypes
  }
)



// WEBPACK FOOTER //
// ./src/components/views/Campaign/config.js